import { Inbox } from 'lucide-react';
import { type ReactNode } from 'react';
import { LinkBase, useTranslate } from 'ra-core';
import { buttonVariants } from '../../components/ui/button';

export type AssignmentEmptyProps = {
  /** Translation key of the message */
  message: string;
  to: string;
  icon: ReactNode;
  /** Label of the link button (translated, falls back to the text itself) */
  label: string;
  /** Whether the link button shows (default: `true`) */
  showLink?: boolean;
};

/**
 * Empty state of the lists that assign something (role users, user group members, KPI assignees): a translated
 * message and a link button to the other list.
 */
export const AssignmentEmpty = ({
  message,
  to,
  icon,
  label,
  showLink = true,
}: AssignmentEmptyProps) => {
  const translate = useTranslate();

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <div className="flex flex-col items-center gap-2 text-muted-foreground">
        <Inbox className="size-24 opacity-50" aria-hidden />
        <p className="text-2xl font-semibold">{translate(message)}</p>
      </div>
      {showLink && (
        <LinkBase to={to} className={buttonVariants({ variant: 'outline' })}>
          {icon}
          {translate(label, { _: label })}
        </LinkBase>
      )}
    </div>
  );
};
